<template>
    <div>
        <div
          class="btn-wrapper d-flex justify-content-md-end justify-content-center"
        >
          <button
            class="btn btn-outline-primary wizard-btn prev-btn"
            @click="previous"
          >
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
            {{ $t("global.return") }}
          </button>
          <button
            class="btn btn-primary wizard-btn next-btn"
            @click="$emit('input', true);$emit('isExternalClient', isExternalClient);"
          >
            {{ $t("global.next") }}
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
        <div class="card card-small mb-4 mt-3">
            <div class="card-body">
                <h5 class="mx-5 my-5">{{ $t("minibus.request.step.two.external.client") }}</h5>
                <fieldset class="my-5 mx-5">
                  <d-form-radio
                    v-model="isExternalClient"
                    :value="false"
                    checked
                    class="mb-3"
                    >Non</d-form-radio
                  >
                  <d-form-radio
                    v-model="isExternalClient"
                    :value="true"
                    class="mb-3"
                    > Oui</d-form-radio
                  >
                </fieldset>
            </div>
        </div>
    </div>
</template>

<script>
import stepForm from '@/components/shared/stepForm';

export default {
  name: 'StepTwoMinibus',
  props: ['user'],
  data () {
    return {
        isExternalClient: false,
    }
  },
  components: {
    stepForm,
  },
  methods : {
    previous() {
      this.$emit('input', null);
    },
  },
  computed: {
    requestButtons() {
      const requestBtns = {
        next: this.$t('global.next'),
      };
      return requestBtns;
    },
    btnPosition() {
      const buttonStyle = {
        btnHistoryClass: 'btn-wrapper d-flex justify-content-between',
        btnClass: 'ml-md-auto mr-md-0 mx-auto',
      };
      return buttonStyle;
    },
  },
};
</script>

<style scoped>
.vacation-heading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: transparent;
  padding: 15px 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 20px 0px #e9ecef;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vacation-heading-wrapper h5 {
  margin-bottom: 0;
  font-weight: bold;
  color: #303778;
}
.vacation-heading-wrapper span {
  color: #303778;
}
.card {
  position: relative;
}
.wizard-btn-wrapper {
  position: absolute;
  top: -120px;
  right: 0;
}
.next-btn {
  border-radius: 5px !important;
  color: #ffffff !important;
}
</style>

